import { render, staticRenderFns } from "./aboutList.vue?vue&type=template&id=af36926e&scoped=true"
import script from "./aboutList.vue?vue&type=script&lang=js"
export * from "./aboutList.vue?vue&type=script&lang=js"
import style0 from "./aboutList.vue?vue&type=style&index=0&id=af36926e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af36926e",
  null
  
)

export default component.exports